//
// Generated class EmployeeCompensationConcept
//

/// <reference path="EmployeeCompensationConcept_ManagedObject.ts" />

class EmployeeCompensationConcept extends EmployeeCompensationConcept_ManagedObject
{

}
